module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('div', {
    staticClass: "modal-default"
  }, [_c('div', {
    staticClass: "modal-default__wrapper"
  }, [_c('div', {
    staticClass: "modal-default__container",
    class: _vm.classes
  }, [(_vm.closeButton) ? _c('button', {
    staticClass: "modal-default__default-button",
    on: {
      "click": _vm.onClick
    }
  }) : _vm._e(), (_vm.header || _vm.$slots.header) ? _c('div', {
    staticClass: "modal-default__header"
  }, [_vm._t("header", [_c('h3', [_vm._v(_vm._s(_vm.header))])])], 2) : _vm._e(), (_vm.text || _vm.$slots.body || _vm.$slots.default) ? _c('div', {
    staticClass: "modal-default__body"
  }, [_vm._t("default", [_c('p', {
    staticClass: "modal-default__text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]), _vm._t("body")], 2) : _vm._e(), (_vm.$slots.footer) ? _c('div', {
    staticClass: "modal-default__footer"
  }, [_vm._t("footer", [_vm._v(_vm._s(_vm.footer))])], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d1791b","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/default/component.vue
// module id = d65cabefc4119c53818a
// module chunks = 89